import "./MainPart.css";
import React, { useState } from "react";
import collapseButtton from "../../assets/images/collapseButtton.svg";
import homeButton from "../../assets/images/homeButton.svg";
import infoButton from "../../assets/images/infoButton.svg";
import allImagesAtOne from "../../assets/newImages/main_cover.webp";
import logoRamMain from "../../assets/images/stuff/RAM_Logo.svg";

function MainPart({ setPhase, phase, setInfoPop, allContent }) {
  const [logoStyle, setLogoStyle] = useState(null);
  const [firstStateOfPhase, setFirstStateOfPhase] = useState(0);

  return (
    <div
      className={
        phase === 0 ? "mainContainer width1112" : "mainContainer width103"
      }
    >
      <div className="mainContainerContent">
        <div className={phase === 0 ? "textContainer" : "displayNone"}>
          <h2>{allContent.main.title1}</h2>
          <h1>{allContent.main.title2}</h1>
          <p>{allContent.main.text1}</p>
          <p>{allContent.main.text2}</p>
          <button
            className="mainButtonApp"
            onClick={() => {
              setPhase(1);
            }}
          >
            {allContent.main.button}
          </button>
        </div>
        <div className={phase === 0 ? "imagesMainPart" : "imagesMainPart"}>
          <img
            className="dots"
            src={process.env.PUBLIC_URL + "/mainPartImages/dots.png"}
            alt="dots"
          />
          <img
            className="curveUp"
            src={process.env.PUBLIC_URL + "/mainPartImages/curveUp.png"}
            alt="curveUp"
          />
          <img
            className="playSmaller"
            src={process.env.PUBLIC_URL + "/mainPartImages/playSmaller.png"}
            alt="playSmaller"
          />
          <img
            className="playBigger"
            src={process.env.PUBLIC_URL + "/mainPartImages/playBigger.png"}
            alt="playBigger"
          />
          <img
            className="unionRight"
            src={process.env.PUBLIC_URL + "/mainPartImages/unionRight.png"}
            alt="unionRight"
          />
          <img
            className="unionLeft"
            src={process.env.PUBLIC_URL + "/mainPartImages/unionLeft.png"}
            alt="unionLeft"
          />
          <img
            className="curveDown"
            src={process.env.PUBLIC_URL + "/mainPartImages/curveDown.png"}
            alt="curveDown"
          />
          <div className="imagesContainerAllAtOne">
            <img
              className="allImagesAtOne"
              src={allImagesAtOne}
              alt="allImagesAtOne"
            />
          </div>
        </div>
        <div className={"smallIconsHolder"}>
          <img
            className={phase === 0 ? "logoBigger" : "logoSmallerNew"}
            src={logoRamMain}
            alt="logoBig"
          />
          <div className={phase === 0 ? "hidenIcons" : "flexButtons"}>
            <img
              id="RAM_BTN_Nav_Home"
              className="homeButon navButtonsLeft"
              onClick={() => {
                setPhase(0);
              }}
              src={homeButton}
              alt="buttonHome"
            />
            <img
              className="navButtonsLeft"
              id="RAM_BTN_Nav_Expand"
              onClick={() => {
                setPhase(1);
              }}
              src={collapseButtton}
              alt="buttonExpand"
            />
          </div>
          <img
            id="RAM_BTN_Nav_Info"
            className={phase === 0 ? "hidenIcons" : "lastButton navButtonsLeft"}
            onClick={() => {
              setInfoPop(1);
            }}
            src={infoButton}
            alt="buttonInfo"
          />
        </div>
      </div>
    </div>
  );
}

export default MainPart;
